import { Alert } from 'antd';
import React from 'react';

import './style.scss'

const MyAlert = ({ content, type, showIcon, icon, ...rest }) => {
  return (
    <div id="my-alert">
      <Alert
        {...rest}
        message={content}
        type={type}
        showIcon={showIcon}
        icon={icon}
      />
    </div>
  );
};

export default MyAlert;
